import '../css/index.css';

/**
 * JS
 */
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import {Router} from 'react-router-dom';
import {routerMiddleware} from 'react-router-redux';
import {createBrowserHistory} from 'history';
import {Provider} from 'react-redux';
import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core';
import {MuiPickersUtilsProvider} from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';
import appReducers from 'reducers';
import App from 'components';
import CssBaseline from '@material-ui/core/CssBaseline';
import * as Sentry from '@sentry/browser';
import {SENTRY_URL} from '../../env';


const history = createBrowserHistory();
const historyMiddleware = routerMiddleware(history);
const middlewares = [
    thunk,
    historyMiddleware,
];

if (process.env.NODE_ENV === 'development') {
    middlewares.push(logger);
}

const store = createStore(
    appReducers,
    applyMiddleware(...middlewares),
);

export const theme = createMuiTheme({
    typography: {
        fontFamily: 'Lato, Laro, Arial, sans-serif',
        useNextVariants: true,
    },
    palette: {
        /*
        background: {
            default: '#0163cc',
        },*/
        primary: {
            main: '#0163cc',
            light: '#f9fafb',
            contrastText: '#fff',
        },
        secondary: {
            main: '#f94a8e',
        },
    },
    overrides: {
        MuiButton: {
            containedPrimary: {
                '&:hover': {
                    backgroundColor: '#639EFB',
                }
            },
            textPrimary: {
                '&:hover': {
                    backgroundColor: '#639EFB33', //20% Opacity
                }
            },
            containedSecondary: {
                '&:hover': {
                    backgroundColor: '#EE70CA',
                }
            },
            textSecondary: {
                '&:hover': {
                    backgroundColor: '#EE70CA33', //20% Opacity
                }
            },
        },
    }
});

Sentry.init({dsn: SENTRY_URL});

ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <MuiThemeProvider theme={theme}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    <CssBaseline/>
                    <App/>
                </MuiPickersUtilsProvider>
            </MuiThemeProvider>
        </Router>
    </Provider>,
    document.getElementById('react-root')
);
